import { ReceivablesUserSettingsModelDto, UserClaimModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../shared';

export class CompanyUserReceivablesSettings extends DomainEntity<ReceivablesUserSettingsModelDto> {
    public createDefault(): this {
        return new CompanyUserReceivablesSettings({}) as this;
    }

    public get remoteDepositProductTypeId() {
        return this.dto.remoteDepositProductTypeId;
    }

    public get ssoLoginId() {
        return this.dto.ssoLoginId;
    }

    public get pendingSsoLoginId() {
        return this.dto.pendingSsoLoginId;
    }

    public set pendingSsoLoginId(value: string | undefined) {
        this.dto.pendingSsoLoginId = value;
    }

    public get ssoAccessKey() {
        return this.dto.ssoAccessKey;
    }

    public get pendingSsoAccessKey() {
        return this.dto.pendingSsoAccessKey;
    }

    public set pendingSsoAccessKey(value: string | undefined) {
        this.dto.pendingSsoAccessKey = value;
    }

    public get userProductClaims(): UserClaimModelDto[] {
        return this.dto.userProductClaims ?? [];
    }

    public set userProductClaims(claims: UserClaimModelDto[]) {
        this.dto.userProductClaims = claims;
    }

    public getRdcSsoClaimIndex(rdcSsoClaimId: number) {
        return this.dto.userProductClaims?.findIndex(c => c.claimId === rdcSsoClaimId) ?? -1;
    }

    public getRdcSsoClaim(rdcSsoClaimId: number): UserClaimModelDto | undefined {
        const idx = this.getRdcSsoClaimIndex(rdcSsoClaimId);
        return idx >= 0 ? this.dto.userProductClaims?.[idx] : undefined;
    }
}
